import React from 'react';
import styled from 'styled-components';
import '../Toolbox.less';
import Tool from '../../components/Tool';

import getStarted from '../../assets/Getting_Started_With_VoiceBase.pdf';
import tutAnd from '../../assets/And_Or_Not Tutorial.pdf';
import tutWildcard from '../../assets/Wildcard_ Tutorial.pdf';
import tutSlop from '../../assets/Slop_Swaps_and_Insertions_Tutorial.pdf';

const GuidesList = styled.ul`
  a {
    color: #96d3f7;
    &:hover {
     color: #ffffff;
    }
  }
`;

const OperatorsTable = styled.table`
  font-size: .8em;
  td {
    padding-bottom: 15px;
  }
  td:first-child, th:first-child {
    text-align: center;
    vertical-align: top;
  }
  code { 
    background-color: #2b455d;
    padding: 4px;
    border-radius: 4px;
    margin-top: 3px;
    display: block;
  }
  a {
    color: #96d3f7;
    &:hover {
     color: #ffffff;
    }
  }
`;

const Documentation = () => {
  return (
    <Tool
      title="Workbench"
      subTitle="Documentation"
    >
      <div style={{padding: '20px'}}>
        <h3>Guides</h3>
        <GuidesList>
          <li><a target="_blank" href={getStarted}>VBQL Manual</a></li>
          <li><a target="_blank" href={tutAnd}>Tutorial: And/Or/Not</a></li>
          <li><a target="_blank" href={tutWildcard}>Tutorial: Wildcards</a></li>
          <li><a target="_blank" href={tutSlop}>Tutorial: Slops, Swaps, and Insertions</a></li>
        </GuidesList>

        <h3>VBQL Operators</h3>
        <OperatorsTable className="table table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>Operator</th>
            <th>Description</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>AND</td>
            <td>
              <h5>And</h5>
              <div>‘And’ for the entire document</div>
              <code title="examples">&quot;home&quot; AND &quot;garden&quot;</code>
            </td>
          </tr>
          <tr>
            <td>OR</td>
            <td>
              <h5>Or</h5>
              <div>‘Or’ for the entire document</div>
              <code title="examples">&quot;carpets&quot; OR &quot;flooring&quot;</code>
            </td>
          </tr>
          <tr>
            <td>AND NOT</td>
            <td>
              <h5>And Not</h5>
              <div>‘And not’ for the entire document</div>
              <code title="examples">&quot;owner&quot; AND NOT &quot;renter&quot;</code>
            </td>
          </tr>
          <tr>
            <td>&amp;&amp;</td>
            <td>
              <h5>Double Ampersand</h5>
              <div>‘And’ for speaker turn</div>
              <code title="examples">&quot;home&quot; &amp;&amp; &quot;owner&quot;</code>
            </td>
          </tr>
          <tr>
            <td>||</td>
            <td>
              <h5>Double Pipe/ Pipes</h5>
              <div>‘Or’ for speaker turn</div>
              <code title="examples">&quot;husband&quot; OR &quot;wife&quot;</code>
            </td>
          </tr>
          <tr>
            <td>!</td>
            <td>
              <h5>Bang</h5>
              <div>‘And Not’ for speaker turn</div>
              <code title="examples">&quot;Customer&quot; says (&quot;need cancel&quot;/1 &amp;&amp; ! &quot;if&quot;)</code>
            </td>
          </tr>
          <tr>
            <td>*</td>
            <td>
              <h5>Wildcard</h5>
              <div>Allows for different endings to one word</div>
              <code title="examples">“insulat*” to find insulate, insulated, and insulation</code>
            </td>
          </tr>
          <tr>
            <td>WITH SLOP</td>
            <td>
              <h5>Slop</h5>
              <div>Insertions or substitutions into phrase of 2 or more terms</div>
              <code title="examples">&quot;Agent&quot; says (&quot;how help today&quot; WITH SLOP 3)</code>
            </td>
          </tr>
          <tr>
            <td>/</td>
            <td>
              <h5>Slop</h5>
              <div>Insertions or substitutions into phrase of 2 or more terms</div>
              <code title="examples">“Agent&quot; says (&quot;how help today&quot;/3)</code>
            </td>
          </tr>
          <tr>
            <td>[beginningtime s, endingtime s]</td>
            <td>
              <h5>Time constraint</h5>
              <div>Narrows a query by turns that start or end within the time frame</div>
              <code title="examples">[0s,180s] or [0%,70%] or [80%,100%] or [,-30s]</code>
            </td>
          </tr>
          <tr>
            <td>FOR [beginningtime s, endingtime s]</td>
            <td>
              <h5>Silence</h5>
              <div></div>
              <code title="examples">SAYS NOTHING FOR [0s,30s]</code>
            </td>
          </tr>
          <tr>
            <td>XOR</td>
            <td>
              <h5>exclusive OR</h5>
              <div>Used to spot 1 of many results exclusively</div>
              <code title="examples">WHERE * says &quot;TV&quot; XOR &quot;internet&quot;</code>
            </td>
          </tr>
          </tbody>
        </OperatorsTable>


      </div>
    </Tool>
  );
}

export default Documentation;
